import dates from 'src/utils/dates'

const entry = {
  defaults: {
    time_entry_date: dates.getLocalDate(),
    person_id: null,
    client_id: null,
    hours: 0,
    minutes: 0,
    time_classification_id: null,
    duration: 0,
    person_email: null,
    description: null,
    project_id: null,
    service_id: null,
  },
}

export default entry
